import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LegalPage from "@/pages/LegalPage";
import { TERMS_CONTENT, PRIVACY_CONTENT } from "@/content/legalContent";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function AdminGate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <span className="font-oswald uppercase tracking-[0.3em] text-sm text-[#A3A3A3] animate-pulse">
          Loading…
        </span>
      </div>
    );
  }
  return user ? <AdminDashboard /> : <Navigate to="/admin" replace />;
}

function AdminEntry() {
  const { user } = useAuth();
  if (user) return <Navigate to="/admin/dashboard" replace />;
  return <AdminLogin />;
}

function App() {
  return (
    <AuthProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid rgba(232,90,36,0.4)",
            color: "#FAFAFA",
            borderRadius: 0,
            fontFamily: "DM Sans, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/terms-and-conditions"
            element={<LegalPage title="Terms & Conditions" lastUpdated="24 July 2026" content={TERMS_CONTENT} />}
          />
          <Route
            path="/privacy-policy"
            element={<LegalPage title="Privacy Policy" lastUpdated="24 July 2026" content={PRIVACY_CONTENT} />}
          />
          <Route path="/admin" element={<AdminEntry />} />
          <Route path="/admin/dashboard" element={<AdminGate />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
